import { Name } from '../../api/agency-api';

export function formatName(name: Name) {
  return `${name.first ?? ''} ${name.middleInitial ?? ''} ${name.last ?? ''}`;
}
